var map = {
	"./bg-BG.json": 6001,
	"./cs-CZ.json": 4236,
	"./da-DK.json": 26644,
	"./de-DE.json": 20043,
	"./el-GR.json": 92279,
	"./en-GB.json": 15810,
	"./es-ES.json": 676,
	"./et-EE.json": 90338,
	"./fi-FI.json": 9818,
	"./fr-FR.json": 24224,
	"./hr-HR.json": 66364,
	"./hu-HU.json": 88723,
	"./it-IT.json": 14298,
	"./lt-LT.json": 15858,
	"./lv-LV.json": 84469,
	"./nb-NO.json": 63633,
	"./nl-NL.json": 18170,
	"./pl-PL.json": 13948,
	"./ro-RO.json": 9411,
	"./sk-SK.json": 75198,
	"./sl-SI.json": 67683,
	"./sv-SE.json": 64123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85512;